var map = {
	"./404.svg": 956,
	"./Categories.png": 957,
	"./Edit-menu.svg": 958,
	"./Egg.svg": 959,
	"./Emaier-Header.png": 960,
	"./Qr-4.png": 961,
	"./_duplicate.svg": 962,
	"./_overview.svg": 963,
	"./add-white.svg": 964,
	"./alert.svg": 965,
	"./all_category.svg": 966,
	"./archive.svg": 967,
	"./armchair.svg": 968,
	"./arrow-circle-right.svg": 969,
	"./arrow-left-circle.svg": 970,
	"./arrow-right-circle.svg": 971,
	"./arrow-right.svg": 972,
	"./asc-up-white.svg": 973,
	"./asc.png": 974,
	"./asc.svg": 975,
	"./back-arrow.svg": 976,
	"./barcode-icon.svg": 977,
	"./beverages.svg": 978,
	"./blue-edit-pen.svg": 979,
	"./blue-eye.svg": 980,
	"./box-office.svg": 981,
	"./broken-seat.jpg": 982,
	"./calendar_list.svg": 983,
	"./calender.svg": 364,
	"./chevron-down.svg": 984,
	"./chevron-left.svg": 985,
	"./cinema-mamagement-sidebar.svg": 986,
	"./claendar.svg": 314,
	"./clock-1.svg": 987,
	"./clock.svg": 988,
	"./close-button.svg": 719,
	"./close-white.svg": 721,
	"./close-x.svg": 309,
	"./collapse-up.svg": 989,
	"./collapse.svg": 990,
	"./connection-lost.svg": 362,
	"./consumable-raw-material.svg": 991,
	"./copy.svg": 992,
	"./copy_image_icon.png": 993,
	"./delete-red-light.svg": 994,
	"./delete-red.svg": 728,
	"./delete.svg": 702,
	"./deliver-icon.svg": 995,
	"./desc-down-white.svg": 996,
	"./desc.svg": 997,
	"./distributors-sidebar.svg": 998,
	"./download.svg": 999,
	"./dragndrop.svg": 1000,
	"./dragndrop2.svg": 1001,
	"./duplicate.svg": 1002,
	"./duplicateScreen.svg": 1003,
	"./e-wallet-icon-black.svg": 1004,
	"./edit-pen-blue.svg": 1005,
	"./edit-pen-white.svg": 1006,
	"./edit-pen.svg": 1007,
	"./edit.svg": 1008,
	"./email.png": 1009,
	"./empty-image.svg": 1010,
	"./excel.svg": 1011,
	"./external-link.svg": 1012,
	"./eye.svg": 1013,
	"./filter-icon.svg": 1014,
	"./flag.svg": 1015,
	"./fnb-app-order.svg": 1016,
	"./fnb-beverages.svg": 1017,
	"./fnb-brownie.svg": 1018,
	"./fnb-combo.svg": 1019,
	"./fnb-desert.svg": 1020,
	"./fnb-eatables.svg": 1021,
	"./fnb-make-your-combo.svg": 1022,
	"./fnb-popcorn.svg": 1023,
	"./fnbtransactionIcon.svg": 1024,
	"./fullscreen-icon.svg": 729,
	"./funnel.svg": 1025,
	"./globe.svg": 1026,
	"./green-tick.svg": 1027,
	"./grid-view.svg": 1028,
	"./hide-password.svg": 365,
	"./home-icon.svg": 1029,
	"./home.svg": 1030,
	"./icon-black-play.svg": 1031,
	"./icon-dot.svg": 1032,
	"./icon-fnb.svg": 1033,
	"./icon-marketing.svg": 1034,
	"./icon-no-seat.png": 1035,
	"./icon-no-seat.svg": 1036,
	"./icon-option.svg": 1037,
	"./icon-poin-of-sale.svg": 1038,
	"./icon-recliner.svg": 1039,
	"./icon-report.svg": 1040,
	"./icon-sofa-dark-1.svg": 1041,
	"./icon-sofa-dark.png": 1042,
	"./icon-sofa-dark.svg": 1043,
	"./icon-sofa.svg": 1044,
	"./importfile.svg": 1045,
	"./info.svg": 722,
	"./info2.svg": 1046,
	"./keyboard-icon.svg": 1047,
	"./kitchen_display.svg": 1048,
	"./language-icon.svg": 366,
	"./left-caret.svg": 1049,
	"./link.svg": 1050,
	"./list-view.svg": 1051,
	"./loading.svg": 367,
	"./lock.svg": 1052,
	"./login-password.png": 368,
	"./login-user.png": 369,
	"./logout.svg": 723,
	"./masters-sidebar.svg": 1053,
	"./merchandise.svg": 1054,
	"./minus.svg": 1055,
	"./movie-pass-svg.svg": 713,
	"./movie-rolling.svg": 1056,
	"./mulitSchedule.svg": 1057,
	"./multicurrency.svg": 1058,
	"./multifnb.svg": 1059,
	"./nav-plus.svg": 1060,
	"./new_filter_icon.svg": 1061,
	"./no-image.svg": 1062,
	"./no-schedule.svg": 142,
	"./non-veg-mark.png": 1063,
	"./non-veg-mark.svg": 1064,
	"./notification.svg": 1065,
	"./open-link-blue.svg": 1066,
	"./openPlanned.svg": 1067,
	"./overview.svg": 1068,
	"./overview2.svg": 1069,
	"./pdf-icon.svg": 1070,
	"./pdf.svg": 1071,
	"./pickup-ticket-icon.svg": 1072,
	"./pickupfnb.svg": 1073,
	"./play.svg": 1074,
	"./plus.svg": 1075,
	"./pointofsale-1.svg": 1076,
	"./pointofsale-2.svg": 1077,
	"./pointofsale.png": 1078,
	"./portfolio.svg": 1079,
	"./pos-fnb-no-itmes.svg": 715,
	"./pos-refresh.svg": 1080,
	"./primary/chevron-down.svg": 1081,
	"./primary/download.svg": 1082,
	"./primary/edit.svg": 1083,
	"./primary/filter.svg": 1084,
	"./primary/printer.svg": 1085,
	"./print-icon.svg": 1086,
	"./print.svg": 1087,
	"./question.svg": 1088,
	"./question1.svg": 1089,
	"./question2.svg": 730,
	"./question3.svg": 1090,
	"./recliner-1.svg": 1091,
	"./recliner.png": 1092,
	"./refund-icon.svg": 1093,
	"./reload-icon-pos.svg": 1094,
	"./reload-icon.svg": 1095,
	"./restore.svg": 1096,
	"./right-caret.svg": 1097,
	"./role-management-sidebar.svg": 1098,
	"./save.svg": 1099,
	"./schedule-icon.svg": 1100,
	"./school-calendar.svg": 1101,
	"./search-global-white.svg": 1102,
	"./search-global.svg": 1103,
	"./search.svg": 731,
	"./searchIcon.svg": 1104,
	"./seat-icon-2.svg": 1105,
	"./seat-icon.svg": 1106,
	"./seat-icons/3-wheelChair.png": 1107,
	"./seat-icons/block_seat_new.png": 1108,
	"./seat-icons/broken-seat-1.svg": 1109,
	"./seat-icons/broken-seat-2.svg": 1110,
	"./select-food.png": 732,
	"./settings.svg": 1111,
	"./show-password.svg": 370,
	"./slider-triangle.svg": 724,
	"./snack.svg": 725,
	"./sort.svg": 1112,
	"./star-empty.svg": 1113,
	"./star-fill.svg": 1114,
	"./success-tick.svg": 1115,
	"./suitcase.svg": 1116,
	"./swap.svg": 1117,
	"./tick-green-item.svg": 733,
	"./tick-green.svg": 1118,
	"./ticket-icon.svg": 1119,
	"./trash.svg": 1120,
	"./unpaid-reservation.svg": 707,
	"./updown-white.svg": 1121,
	"./updown.svg": 1122,
	"./user-attribute.svg": 1123,
	"./user-attributes.svg": 1124,
	"./user-female.svg": 1125,
	"./user-male-white.svg": 1126,
	"./user-male.svg": 1127,
	"./user-profile.svg": 1128,
	"./userProfile.png": 1129,
	"./veg-food-mark-white.png": 1130,
	"./veg-foog-mark-trans.png": 1131,
	"./view.png": 1132,
	"./view.svg": 1133
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 955;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 955
// module chunks = 37